var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [
        _vm.organizationUnitId
          ? _c("AdminNavigationV2", { attrs: { tid: _vm.organizationUnitId } })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v(_vm._s(_vm.title))]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: {
                href: `/#/admin/organizations/workspaces/${_vm.organizationUnitId}`,
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-arrow-left",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Back")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: {
                href: `/#/admin/organizations/workspaces/edit/${_vm.id}`,
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-pencil",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Edit")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-lg-5 text-right" },
          [
            _c(
              "FileUploader",
              {
                attrs: { ttl: 60, skipConfirmation: true, hideProgress: true },
                on: {
                  selected: function ($event) {
                    _vm.file = $event
                  },
                  uploaded: _vm.handleFileUploaded,
                },
              },
              [
                _c(
                  "button",
                  { staticClass: "btn btn-success", attrs: { type: "button" } },
                  [_vm._v("Upload portfolio")]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _vm.usersInWorkspace.length
        ? _c("div", { staticStyle: { "margin-bottom": "50px" } }, [
            _c("h4", { staticClass: "fg-color-blue" }, [_vm._v("Members")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("table", { staticClass: "table table-striped table-hover" }, [
              _c(
                "tbody",
                _vm._l(_vm.usersInWorkspace, function (u) {
                  return _c("tr", [
                    _c("td", [_vm._v(_vm._s(u.DisplayName))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(u.Email))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(u.IsExternal ? "External" : "Organization")
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary btn-sm pull-right",
                          on: {
                            click: function ($event) {
                              return _vm.handleRemoveUserFromWorkspaceCommandV1(
                                u
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                                Remove an access\n                            "
                          ),
                        ]
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-bottom": "40px" } }, [
        _c("h4", { staticClass: "fg-color-blue" }, [
          _vm._v("Invite people from outside the organization"),
        ]),
        _vm._v(" "),
        _vm.invitations.length
          ? _c(
              "ul",
              _vm._l(_vm.invitations, function (email) {
                return _c("li", { key: email }, [
                  _vm._v("Pending invitation for " + _vm._s(email)),
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "input-group mb-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.inputRecipientEmail,
                expression: "inputRecipientEmail",
                modifiers: { trim: true },
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "By email" },
            domProps: { value: _vm.inputRecipientEmail },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.inputRecipientEmail = $event.target.value.trim()
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "input-group-append" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.handleInviteToWorkspaceCommandV1 },
              },
              [_vm._v("Invite")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.usersNotInWorkspace, function (u) {
            return _c(
              "div",
              {
                staticClass: "col-sm-6",
                staticStyle: { "margin-bottom": "20px" },
              },
              [
                _c("div", { staticClass: "card bg-light" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _vm._v(
                      "\n                            Organization user\n                            "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-sm pull-right",
                        on: {
                          click: function ($event) {
                            return _vm.handleAddUserToWorkspaceCommandV1(u)
                          },
                        },
                      },
                      [
                        _vm._v("\n                                Add "),
                        _c("i", {
                          staticClass: "fa fa-plus",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body" }, [
                    _c("h5", { staticClass: "card-title" }, [
                      _vm._v(_vm._s(u.DisplayName)),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "card-text" }, [
                      _c("em", [_vm._v(_vm._s(u.Email))]),
                    ]),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }